const BalanceCard = ({
    isFirst = false,
    type,
    amount,
    color = 'bg-blue-500',
    gradient = 'from-[#EFF6FF] to-[#ffff]',
    icon,
    className = '',
    innerClassName = '',
    titleClass = '',
    amountClass = '',
    onClick,
    prefix = '',
    suffix = '',
}) => {
    return (
        <div
            className={`${isFirst ? 'col-span-2' : ''} rounded-2xl p-3 shadow-md border border-white bg-gradient-to-tl ${gradient} ${className} ${onClick ? 'cursor-pointer hover:shadow-lg transition-shadow' : ''}`}
            onClick={onClick}
        >
            <div className={`flex items-center ${innerClassName}`}>
                <div className={`p-2 ${color} rounded-[10px] flex flex-col items-center justify-center`}>
                    {icon}
                </div>
                <div>
                    <h3 className={`text-xs font-bold leading-5 ml-2 text-gray-700 ${titleClass}`}>{type}</h3>
                    <p className={`text-sm font-bold ms-2 text-gray-900 ${amountClass}`}>{prefix} {amount || 0} {suffix}</p>
                </div>
            </div>
        </div>
    );
};

export default BalanceCard;
